import { RedirectFunction } from '@angular/router';
import { EventKinds } from './event-status';
import { eventDetail, eventEdit, eventsOfKind, newEventOfKind } from './routes';

/**
 * Where the old `/tournaments*` URLs go now that a tournament is an event with
 * `kind = Tournament`.
 *
 * These are not tidiness. Venues have the tournament screens bookmarked, our own emails link to
 * them, and a manager's browser history is full of them. A dead `/tournaments/{id}` would read
 * as "the platform lost my tournament" rather than "that page moved".
 *
 * They are functions rather than plain `redirectTo` strings because two of the four targets
 * carry a query param, which the string form cannot express. Each returns the same URL the app
 * would build for itself — no second spelling of an events route lives here.
 */

/** `/tournaments` → the events list, showing tournaments only. */
export const tournamentListRedirect: RedirectFunction = () =>
  eventsOfKind(EventKinds.Tournament);

/** `/tournaments/new` → the create form, started on the tournament kind. */
export const tournamentNewRedirect: RedirectFunction = () =>
  newEventOfKind(EventKinds.Tournament);

/**
 * `/tournaments/{id}` → `/events/{id}`. Ids survived the migration unchanged (the plan's
 * "same `Id`" rule), so an old link still points at the same tournament.
 */
export const tournamentDetailRedirect: RedirectFunction = data =>
  eventDetail(data.params['id']);

/** `/tournaments/{id}/edit` → `/events/{id}/edit`. */
export const tournamentEditRedirect: RedirectFunction = data =>
  eventEdit(data.params['id']);
